import React from 'react'

const Badge = React.forwardRef(({ className = '', variant = 'default', ...props }, ref) => {
  const baseStyles = 'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2'
  
  const variants = {
    default: 'border-transparent bg-gray-500 dark:bg-gray-600 text-white dark:text-gray-100 hover:bg-gray-600 dark:hover:bg-gray-700',
    secondary: 'border-transparent bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-gray-100 hover:bg-gray-200 dark:hover:bg-gray-700',
    destructive: 'border-transparent bg-red-500 dark:bg-red-600 text-white dark:text-red-100 hover:bg-red-600 dark:hover:bg-red-700',
    outline: 'border-gray-300 dark:border-gray-600 text-gray-900 dark:text-gray-100 hover:bg-gray-50 dark:hover:bg-gray-800'
  }
  
  const variantStyles = variants[variant] || variants.default
  
  return (
    <div 
      ref={ref}
      className={`${baseStyles} ${variantStyles} ${className}`}
      {...props}
    />
  )
})

Badge.displayName = 'Badge'

export { Badge }
